import { w as r } from "./well-known-symbol.js";
import { i as o } from "./iterators.js";
var t = r("iterator"),
  a = Array.prototype,
  i = function i(r) {
    return void 0 !== r && (o.Array === r || a[t] === r);
  };
export { i };